
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface TravelBlockCancelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  travelBlock: any;
  onConfirm: () => Promise<void>;
  loading?: boolean;
}

export const TravelBlockCancelDialog: React.FC<TravelBlockCancelDialogProps> = ({
  isOpen,
  onClose,
  travelBlock,
  onConfirm,
  loading = false
}) => {
  const formatTime = (timeString: string) => {
    try {
      const date = new Date(timeString);
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch (error) {
      return 'Invalid time';
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Cancel Travel Block</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {travelBlock && (
            <div className="text-sm">
              <p>Are you sure you want to cancel this travel time block?</p>
              <div className="mt-2 p-3 bg-gray-50 rounded-md">
                <p><strong>Time:</strong> {formatTime(travelBlock.start_time)} - {formatTime(travelBlock.end_time)}</p>
                <p className="text-gray-500 text-xs mt-1">This is a travel time block automatically generated for a booking.</p>
              </div>
            </div>
          )}
          
          <div className="flex gap-3 justify-end">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Keep Block
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? "Cancelling..." : "Cancel Block"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
